import { render } from "./ApModalBase.vue?vue&type=template&id=15479f09&ts=true"
import script from "./ApModalBase.vue?vue&type=script&lang=ts"
export * from "./ApModalBase.vue?vue&type=script&lang=ts"

import "./ApModalBase.vue?vue&type=style&index=0&id=15479f09&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__